import React from 'react';
import { Navigate } from 'react-router-dom';
import { useModuleAccess } from '../hooks/useModuleAccess';

type Props = {
  moduleName: string;
  permission: 'view' | 'edit';
  children: JSX.Element;
};

const ModuleProtectedRoute = ({ moduleName, permission, children }: Props) => {
  const { canView, canEdit } = useModuleAccess(moduleName);

  const isAllowed = permission === 'view' ? canView : canEdit;

  if (!isAllowed) return <Navigate to="/utilization/health-checks" replace />;
  return children;
};

export default ModuleProtectedRoute;
